<template>
  <l-marker
    :lat-lng="latLng"
    :icon="icon(color)"
  >
    <l-popup v-if="popup">
      <span v-html="popup"></span>
    </l-popup>
    <l-tooltip v-if="tooltip">
      <span v-html="tooltip"></span>
    </l-tooltip>
  </l-marker>
</template>

<script>
import { LMarker, LPopup, LTooltip } from "vue2-leaflet";
import { Icon } from "leaflet";

export default {
  name: "BaseMarker",
  components: {
    LMarker,
    LPopup,
    LTooltip
  },
  props: {
    // LMarker propertise
    latLng: {
      type: [Object, Array],
      required: true
    },
    // LPopup properties
    popup: {
      type: String,
      default: null
    },
    // LTooltip properties
    tooltip: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: 'blue'
    }
  },
  computed: {
    defaultColors() {
      return [
        'blue',
        'red',
        'green',
        'yellow',
        'orange',
        'violet',
        'grey',
      ];
    },
    defaultColorsCode() {
      return [
        '#2A81CB',
        '#CB293C',
        '#25AC22',
        '#CBC529',
        '#CB852B',
        '#9B27CB',
        '#797979',
      ];
    },
  },
  methods: {
    icon(color) {
      return new L.Icon({
        iconUrl:
          "//cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-" + color + ".png",
        shadowUrl:
          "//cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      })
    },
  },
}
</script>

<style>
</style>
